import React from "react";
import { SocialAuth } from "./SocialAuth";

export function Threads() {
  return (
    <SocialAuth platform="threads" title="Threads" showRefreshButton={false} />
  );
}
